<template>
  <div class="success-message">
    <div class="success-content">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" fill="none"/>
      </svg>
      <span>Bug report sent successfully!</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessMessage'
}
</script>

<style scoped>
.success-message {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10001;
  background: #10b981;
  color: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease;
}

.success-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>